import { Partner } from '@monorepo/types';
import { getEnv } from '@hub/helpers/getters.store';
import PartnerService from '@hub/services/entities/partner-service';
import { EntityStore } from '../base/entity-store';

export class PartnerStore extends EntityStore<PartnerService, Partner> {
  constructor() {
    const {
      apiFactory: { partnerService },
    } = getEnv();

    super(partnerService);
  }
}
